(() => {
  const initializeSlider = (slider) => {
    if (slider.dataset.ibgSliderReady === 'true') return;

    const track = slider.querySelector('[data-ibg-slider-track]');
    const slides = Array.from(slider.querySelectorAll('[data-ibg-slide]'));
    const dots = Array.from(slider.querySelectorAll('[data-ibg-slider-dot]'));
    const previous = slider.querySelector('[data-ibg-slider-previous]');
    const next = slider.querySelector('[data-ibg-slider-next]');

    if (!track || slides.length === 0) return;

    slider.dataset.ibgSliderReady = 'true';
    let activeIndex = 0;
    let frame;
    let drag;
    let suppressClick = false;

    const positions = () => {
      const trackRect = track.getBoundingClientRect();
      const padding = parseFloat(getComputedStyle(track).scrollPaddingLeft) || 0;
      const maximum = Math.max(0, track.scrollWidth - track.clientWidth);

      return slides.map((slide) => {
        const slideRect = slide.getBoundingClientRect();
        const alignment = getComputedStyle(slide).scrollSnapAlign;
        const offset = alignment === 'center' ? (track.clientWidth - slideRect.width) / 2 : padding;
        return Math.max(0, Math.min(maximum, track.scrollLeft + slideRect.left - trackRect.left - offset));
      });
    };

    const update = () => {
      const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
      let closestDistance = Number.POSITIVE_INFINITY;

      slider.dataset.ibgSliderScrollable = String(maximum > 1);

      if (track.scrollLeft <= 1) {
        activeIndex = 0;
      } else if (maximum - track.scrollLeft <= 1) {
        activeIndex = slides.length - 1;
      } else {
        positions().forEach((left, index) => {
          const distance = Math.abs(left - track.scrollLeft);

          if (distance < closestDistance) {
            closestDistance = distance;
            activeIndex = index;
          }
        });
      }

      dots.forEach((dot, index) => dot.classList.toggle('is-active', index === activeIndex));

      if (previous) previous.disabled = track.scrollLeft <= 1;
      if (next) next.disabled = maximum - track.scrollLeft <= 1;
    };

    const scrollTo = (left) => {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollTo({ left, behavior: reduceMotion ? 'auto' : 'smooth' });
    };

    const step = (direction) => {
      const stops = positions();
      const left = direction > 0
        ? stops.find((position) => position > track.scrollLeft + 1)
        : stops.reverse().find((position) => position < track.scrollLeft - 1);
      if (left !== undefined) scrollTo(left);
    };

    track.addEventListener('scroll', () => {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(update);
    }, { passive: true });

    previous?.addEventListener('click', () => step(-1));
    next?.addEventListener('click', () => step(1));

    track.addEventListener('keydown', (event) => {
      if (event.target !== track || track.scrollWidth <= track.clientWidth) return;
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      if (event.key === 'Home') scrollTo(0);
      else if (event.key === 'End') scrollTo(track.scrollWidth - track.clientWidth);
      else step(event.key === 'ArrowRight' ? 1 : -1);
    });

    if (track.matches('.ibg-benefits__list, .ibg-values__track, .ibg-teams__track, .ibg-article-related__track')) {
      track.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        if (track.matches('.ibg-article-related__track') && window.matchMedia('(max-width: 740px)').matches) return;
        if (track.scrollWidth <= track.clientWidth || event.target.closest('button, input, textarea, select')) return;
        suppressClick = false;
        drag = { pointerId: event.pointerId, x: event.clientX, left: track.scrollLeft, active: false };
      });

      track.addEventListener('pointermove', (event) => {
        if (!drag || event.pointerId !== drag.pointerId) return;
        const distance = event.clientX - drag.x;
        if (!drag.active && Math.abs(distance) < 5) return;
        if (!drag.active) {
          drag.active = true;
          track.setPointerCapture(event.pointerId);
          track.classList.add('is-dragging');
        }
        event.preventDefault();
        track.scrollLeft = drag.left - distance;
      });

      const finishDrag = (event) => {
        if (!drag || event.pointerId !== drag.pointerId) return;
        suppressClick = drag.active;
        drag = undefined;
        track.classList.remove('is-dragging');
        if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
      };

      track.addEventListener('pointerup', finishDrag);
      track.addEventListener('pointercancel', finishDrag);
      track.addEventListener('lostpointercapture', finishDrag);
      track.addEventListener('pointerleave', (event) => {
        if (!drag?.active) finishDrag(event);
      });
      track.addEventListener('dragstart', (event) => {
        if (drag) event.preventDefault();
      });
      track.addEventListener('click', (event) => {
        if (!suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
        suppressClick = false;
      }, true);
    }

    if ('ResizeObserver' in window) {
      new ResizeObserver(update).observe(track);
    }

    update();
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll('[data-ibg-slider]').forEach(initializeSlider);
  };

  initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
